(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nakonten-brand-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nakonten-brand-slider')) {
  class NakontenBrandSlider extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      this._frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected || this._initialized || !this.querySelector('.nk-controls')) return;
      this._initialized = true;
      const options = { signal: this._abort.signal };
      this.slides = Array.from(this.querySelectorAll('.nk-slide'));
      this.dots = Array.from(this.querySelectorAll('.nk-dot'));
      this.status = this.querySelector('.nk-status');
      this.pauseButton = this.querySelector('.nk-pause');
      this.index = 0;
      this.userPaused = false;
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.editorSelected = false;
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.autoEnabled = this.dataset.autoplay === 'true';
      this.delay = Math.max(3, Number(this.dataset.interval) || 6) * 1000;
      this.querySelector('.nk-prev')?.addEventListener('click', () => this.go(this.index - 1, true), options);
      this.querySelector('.nk-next')?.addEventListener('click', () => this.go(this.index + 1, true), options);
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true), options));
      this.pauseButton?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.refreshPauseButton();
        this.schedule();
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
      }, options);
      this.addEventListener('keydown', event => {
        if (event.target.closest('a,input,textarea,select')) return;
        let target;
        if (event.key === 'ArrowRight') target = this.index + 1;
        if (event.key === 'ArrowLeft') target = this.index - 1;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.slides.length - 1;
        if (target === undefined || this.slides.length < 2) return;
        event.preventDefault();
        this.go(target, true);
        this.dots[this.index]?.focus({ preventScroll: true });
      }, options);
      const stage = this.querySelector('.nk-stage');
      stage?.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' && event.isPrimary) this.startPoint = { x: event.clientX, y: event.clientY };
      }, options);
      stage?.addEventListener('pointercancel', () => { this.startPoint = null; }, options);
      stage?.addEventListener('pointerup', event => {
        if (!this.startPoint) return;
        const dx = event.clientX - this.startPoint.x;
        const dy = event.clientY - this.startPoint.y;
        this.startPoint = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) this.go(this.index + (dx < 0 ? 1 : -1), true);
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      document.addEventListener('shopify:block:select', event => {
        const i = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (i < 0) return;
        this.editorSelected = true;
        this.go(i, false);
      }, options);
      document.addEventListener('shopify:block:deselect', event => {
        if (!this.slides.some(slide => slide.dataset.blockId === event.detail?.blockId)) return;
        this.editorSelected = false;
        this.schedule();
      }, options);
      this.motionQuery.addEventListener('change', () => { this.refreshPauseButton(); this.schedule(); }, options);
      this.resizeObserver = new ResizeObserver(() => this.setViewport());
      this.resizeObserver.observe(document.documentElement);
      this.setViewport();
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: .1 });
      this.observer.observe(this);
      this.querySelector('.nk-controls').hidden = this.slides.length < 2;
      this.querySelectorAll('.nk-arrow').forEach(button => { button.hidden = this.slides.length < 2; });
      this.refreshPauseButton();
      this.go(0, false);
    }
    setViewport() {
      if (this.dataset.fullBleed === 'true') this.style.setProperty('--nk-viewport', `${document.documentElement.clientWidth}px`);
    }
    refreshPauseButton() {
      if (!this.pauseButton) return;
      this.pauseButton.hidden = !this.autoEnabled || this.motionQuery.matches || this.slides.length < 2;
      this.pauseButton.setAttribute('aria-pressed', String(this.userPaused));
      this.pauseButton.setAttribute('aria-label', this.userPaused ? 'Пусни автоматичната смяна' : 'Спри автоматичната смяна');
    }
    go(index, manual) {
      if (!this.slides.length) return;
      this.index = (index % this.slides.length + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      const currentDot = this.dots[this.index];
      if (currentDot) {
        const strip = currentDot.parentElement;
        const left = currentDot.getBoundingClientRect().left - strip.getBoundingClientRect().left + strip.scrollLeft;
        if (left < strip.scrollLeft || left + currentDot.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = left - (strip.clientWidth - currentDot.offsetWidth) / 2;
      }
      if (manual) {
        this.userPaused = true;
        this.refreshPauseButton();
        this.status.textContent = `${this.slides[this.index].dataset.brand}, ${this.index + 1} от ${this.slides.length}`;
      }
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.autoEnabled || this.userPaused || this.hovered || this.focused || !this.visible || this.editorSelected || this.motionQuery.matches || document.hidden || window.Shopify?.designMode || this.slides.length < 2) return;
      this.timer = setTimeout(() => this.go(this.index + 1, false), this.delay);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      cancelAnimationFrame(this._frame);
      this._abort?.abort();
      this._abort = null;
      this._initialized = false;
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
    }
  }
  customElements.define('nakonten-brand-slider', NakontenBrandSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rested-flip-to-win"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('rested-flip-to-win')) return;

    class RestedFlipToWin extends HTMLElement {
      constructor() {
        super();
        this.flippedIndexes = new Set();
        this.flippedCount = 0;
        this.timers = [];
        this.confettiColors = ['#2dd4aa', '#0f766e', '#facc15', '#f8fafc', '#60a5fa', '#fb7185'];
      }

      connectedCallback() {
        if (this.isReady) return;
        this.isReady = true;
        this.requiredPicks = Math.max(1, Number.parseInt(this.dataset.requiredPicks, 10) || 4);
        this.cards = Array.from(this.querySelectorAll('[data-rested-card]'));
        this.cta = this.querySelector('[data-rested-cta]');
        this.won = this.querySelector('[data-rested-won]');
        this.status = this.querySelector('[data-rested-status]');
        this.congrats = this.querySelector('[data-rested-congrats]');
        this.subline = this.querySelector('[data-rested-subline]');
        this.hint = this.querySelector('[data-rested-hint]');
        this.prizes = this.getPrizePool();
        this.onCardClick = this.handleCardClick.bind(this);
        this.onClaimClick = this.continueToOffer.bind(this);

        this.cards.forEach((card) => card.addEventListener('click', this.onCardClick));
        this.cta?.addEventListener('click', this.onClaimClick);
      }

      disconnectedCallback() {
        this.cards?.forEach((card) => card.removeEventListener('click', this.onCardClick));
        this.cta?.removeEventListener('click', this.onClaimClick);
        this.timers.forEach((timer) => window.clearTimeout(timer));
        this.timers = [];
        this.isReady = false;
      }

      getPrizePool() {
        const configured = Array.from(this.querySelectorAll('[data-rested-prize]'))
          .map((prize) => ({
            name: prize.dataset.name?.trim(),
            image: prize.dataset.image || '',
            imageAlt: prize.dataset.imageAlt || prize.dataset.name || '',
            emoji: prize.dataset.emoji || '🎁'
          }))
          .filter((prize) => prize.name);

        if (configured.length) return configured;

        return [
          { name: 'БЕЗПЛАТНА ДОСТАВКА', image: '', imageAlt: '', emoji: '📦' },
          { name: '10% ОТСТЪПКА', image: '', imageAlt: '', emoji: '🏷️' },
          { name: 'ЛЕПЕНКИ ЗА НОС', image: '', imageAlt: '', emoji: '🌙' },
          { name: 'ЛЕПЕНКИ ЗА УСТА', image: '', imageAlt: '', emoji: '😴' }
        ];
      }

      handleCardClick(event) {
        const card = event.currentTarget;
        const index = Number.parseInt(card.dataset.cardIndex, 10);

        if (this.flippedIndexes.has(index) || this.flippedCount >= this.requiredPicks) return;

        // Pick order determines the reward. Card position never changes the four-gift outcome.
        const prize = this.prizes[this.flippedCount % this.prizes.length];
        this.flippedIndexes.add(index);
        this.flippedCount += 1;
        this.fillPrize(card, prize);
        card.classList.add('is-flipped');
        card.disabled = true;
        card.setAttribute('aria-pressed', 'true');
        card.setAttribute('aria-label', `${this.dataset.revealedLabel}: ${prize.name}`);

        if (this.won) this.won.textContent = String(this.flippedCount);
        if (this.status) this.status.textContent = `${this.dataset.revealedLabel}: ${prize.name}. ${this.flippedCount}/${this.requiredPicks}`;

        if (this.flippedCount >= this.requiredPicks) {
          this.finishGame();
        } else {
          this.updateRemainingLabel();
        }
      }

      fillPrize(card, prize) {
        const imageWrap = card.querySelector('[data-rested-prize-image]');
        const name = card.querySelector('[data-rested-prize-name]');
        if (!imageWrap || !name) return;

        imageWrap.replaceChildren();
        name.textContent = prize.name;

        if (prize.image) {
          const image = document.createElement('img');
          image.src = prize.image;
          image.alt = prize.imageAlt;
          image.loading = 'eager';
          imageWrap.appendChild(image);
          return;
        }

        const emoji = document.createElement('span');
        emoji.className = 'rested-flip__prize-emoji';
        emoji.textContent = prize.emoji;
        emoji.setAttribute('aria-hidden', 'true');
        imageWrap.appendChild(emoji);
      }

      updateRemainingLabel() {
        if (!this.cta) return;
        const remaining = this.requiredPicks - this.flippedCount;
        const template = remaining === 1 ? this.dataset.remainingOne : this.dataset.remainingMany;
        this.cta.textContent = (template || '[count]').replace('[count]', String(remaining));
      }

      finishGame() {
        this.setTimer(() => {
          this.cards.forEach((card, index) => {
            card.disabled = true;
            if (!this.flippedIndexes.has(index)) card.classList.add('is-locked');
          });
        }, 450);

        this.setTimer(() => {
          this.congrats?.classList.add('is-visible');
          this.subline?.classList.add('is-hidden');
          this.hint?.classList.add('is-hidden');

          if (this.cta) {
            this.cta.disabled = false;
            this.cta.setAttribute('aria-disabled', 'false');
            this.cta.classList.add('is-active');
            this.cta.textContent = this.dataset.claimLabel || 'Вземи подаръците';
          }

          if (this.dataset.showConfetti === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.launchConfetti();
          }

          const autoRedirect = this.dataset.autoRedirect === 'true';
          const claimLink = this.dataset.claimLink?.trim();
          const inThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
          if (autoRedirect && claimLink && !inThemeEditor) {
            const delay = Math.max(1, Number.parseInt(this.dataset.redirectDelay, 10) || 5) * 1000;
            this.setTimer(() => this.continueToOffer(), delay);
          }
        }, 680);
      }

      continueToOffer() {
        if (!this.cta || this.cta.disabled) return;

        const link = this.dataset.claimLink?.trim();
        if (link) {
          window.location.assign(link);
          return;
        }

        let target = null;
        const selector = this.dataset.scrollTarget?.trim();
        if (selector) {
          try {
            target = document.querySelector(selector);
          } catch (error) {
            target = null;
          }
        }

        if (!target) {
          const sectionWrapper = this.closest('.shopify-section');
          target = sectionWrapper?.nextElementSibling || document.querySelector('form[action*="/cart/add"]');
        }

        target?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }

      launchConfetti() {
        for (let index = 0; index < 80; index += 1) {
          this.setTimer(() => this.spawnConfettiPiece(), index * 24);
        }
      }

      spawnConfettiPiece() {
        const piece = document.createElement('span');
        piece.className = 'rested-flip__confetti';
        piece.style.left = `${Math.random() * 100}vw`;
        piece.style.background = this.confettiColors[Math.floor(Math.random() * this.confettiColors.length)];
        piece.style.width = `${6 + Math.random() * 6}px`;
        piece.style.height = `${10 + Math.random() * 8}px`;
        piece.style.borderRadius = Math.random() > 0.5 ? '50%' : '1px';
        piece.style.transform = `rotate(${Math.random() * 360}deg)`;
        piece.style.animationDuration = `${1.6 + Math.random() * 1.8}s`;
        piece.style.animationDelay = `${Math.random() * 0.35}s`;
        this.appendChild(piece);
        piece.addEventListener('animationend', () => piece.remove(), { once: true });
      }

      setTimer(callback, delay) {
        const timer = window.setTimeout(() => {
          this.timers = this.timers.filter((item) => item !== timer);
          callback();
        }, delay);
        this.timers.push(timer);
        return timer;
      }
    }

    customElements.define('rested-flip-to-win', RestedFlipToWin);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rested-wheel-to-win"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('rested-wheel-to-win')) return;

    class RestedWheelToWin extends HTMLElement {
      constructor() {
        super();
        this.isSpinning = false;
        this.rotation = 0;
        this.spinCount = 0;
        this.lastPrize = null;
        this.timers = [];
      }

      connectedCallback() {
        if (this.isReady) return;
        this.isReady = true;

        this.wheel = this.querySelector('[data-rww-wheel]');
        this.segments = this.querySelector('[data-rww-segments]');
        this.labels = this.querySelector('[data-rww-labels]');
        this.dividers = this.querySelector('[data-rww-dividers]');
        this.spinButton = this.querySelector('[data-rww-spin]');
        this.spinText = this.querySelector('[data-rww-spin-text]');
        this.result = this.querySelector('[data-rww-result]');
        this.resultMedia = this.querySelector('[data-rww-result-media]');
        this.resultTitle = this.querySelector('[data-rww-result-title]');
        this.resultSubtitle = this.querySelector('[data-rww-result-subtitle]');
        this.couponWrap = this.querySelector('[data-rww-coupon-wrap]');
        this.couponLabel = this.querySelector('[data-rww-coupon-label]');
        this.coupon = this.querySelector('[data-rww-coupon]');
        this.copyButton = this.querySelector('[data-rww-copy]');
        this.copyLabel = this.querySelector('[data-rww-copy-label]');
        this.claimButton = this.querySelector('[data-rww-claim]');
        this.status = this.querySelector('[data-rww-status]');
        this.spins = this.querySelector('[data-rww-spins]');
        this.hint = this.querySelector('[data-rww-hint]');

        this.prizes = this.getPrizes();
        this.storageKey = `rested-wheel:${this.dataset.sectionId || 'default'}`;
        this.restoreState();
        this.renderWheel();
        this.updateControls();

        this.onSpin = this.spin.bind(this);
        this.onClaim = this.claim.bind(this);
        this.onCopy = this.copyCoupon.bind(this);
        this.spinButton?.addEventListener('click', this.onSpin);
        this.claimButton?.addEventListener('click', this.onClaim);
        this.copyButton?.addEventListener('click', this.onCopy);
      }

      disconnectedCallback() {
        this.spinButton?.removeEventListener('click', this.onSpin);
        this.claimButton?.removeEventListener('click', this.onClaim);
        this.copyButton?.removeEventListener('click', this.onCopy);
        this.timers.forEach((timer) => window.clearTimeout(timer));
        this.timers = [];
        this.isReady = false;
      }

      getPrizes() {
        return Array.from(this.querySelectorAll('[data-rww-prize]'))
          .map((node, arrayIndex) => ({
            arrayIndex,
            index: Math.max(1, Number.parseInt(node.dataset.index, 10) || arrayIndex + 1),
            title: node.dataset.title?.trim() || 'ПОДАРЪК',
            shortTitle: node.dataset.shortTitle?.trim() || node.dataset.title?.trim() || 'ПОДАРЪК',
            subtitle: node.dataset.subtitle?.trim() || '',
            emoji: node.dataset.emoji || '🎁',
            image: node.dataset.image || '',
            imageAlt: node.dataset.imageAlt || node.dataset.title || '',
            displayMode: (() => {
              const own = node.dataset.displayMode || 'inherit';
              const fallback = ['both', 'image_only', 'text_only'].includes(this.dataset.defaultDisplayMode) ? this.dataset.defaultDisplayMode : 'both';
              return ['both', 'image_only', 'text_only'].includes(own) ? own : fallback;
            })(),
            imageSize: (() => {
              const fallback = Math.max(24, Math.min(160, Number.parseInt(this.dataset.defaultImageSize, 10) || 56));
              const value = Number.parseInt(node.dataset.imageSize, 10);
              return Math.max(24, Math.min(160, Number.isFinite(value) ? value : fallback));
            })(),
            imageRadial: (() => {
              const fallback = Math.max(-140, Math.min(140, Number.parseInt(this.dataset.defaultImageRadial, 10) || 0));
              const value = Number.parseInt(node.dataset.imageRadial, 10);
              return Math.max(-140, Math.min(140, Number.isFinite(value) ? value : fallback));
            })(),
            imageSide: (() => {
              const fallback = Math.max(-140, Math.min(140, Number.parseInt(this.dataset.defaultImageSide, 10) || 0));
              const value = Number.parseInt(node.dataset.imageSide, 10);
              return Math.max(-140, Math.min(140, Number.isFinite(value) ? value : fallback));
            })(),
            imageRotation: (() => {
              const fallback = Math.max(-180, Math.min(180, Number.parseInt(this.dataset.defaultImageRotation, 10) || 0));
              const value = Number.parseInt(node.dataset.imageRotation, 10);
              return Math.max(-180, Math.min(180, Number.isFinite(value) ? value : fallback));
            })(),
            weight: Math.max(0, Number.parseFloat(node.dataset.weight) || 0),
            enabled: node.dataset.enabled !== 'false',
            bg: node.dataset.bg || '#eafff8',
            text: node.dataset.text || '#0b1220',
            coupon: node.dataset.coupon?.trim() || '',
            link: node.dataset.link?.trim() || ''
          }))
          .filter((prize) => prize.enabled && prize.title);
      }

      renderWheel() {
        if (!this.wheel || !this.segments || !this.labels || !this.prizes.length) return;

        const count = this.prizes.length;
        const step = 360 / count;
        const gradient = this.prizes.map((prize, index) => {
          const start = index * step;
          const end = (index + 1) * step;
          return `${prize.bg} ${start}deg ${end}deg`;
        }).join(', ');

        this.segments.style.background = `conic-gradient(from 0deg, ${gradient})`;
        this.labels.replaceChildren();
        this.dividers?.replaceChildren();

        this.prizes.forEach((prize, index) => {
          const centerAngle = (index + 0.5) * step;
          const label = document.createElement('div');
          label.className = `rested-wheel__segment-label rested-wheel__segment-label--${prize.displayMode.replace('_', '-')}`;
          label.style.setProperty('--segment-text', prize.text);
          label.style.setProperty('--segment-image-size', `${prize.imageSize}px`);
          label.style.setProperty('--segment-image-radial', `${prize.imageRadial}px`);
          label.style.setProperty('--segment-image-side', `${prize.imageSide}px`);
          label.style.setProperty('--segment-image-rotation', `${prize.imageRotation}deg`);
          label.style.transform = `translateY(-50%) rotate(${centerAngle - 90}deg)`;

          if (prize.displayMode !== 'text_only') {
            const icon = document.createElement('span');
            icon.className = 'rested-wheel__segment-icon';
            if (prize.image) {
              const image = document.createElement('img');
              image.src = prize.image;
              image.alt = '';
              image.loading = 'eager';
              icon.appendChild(image);
            } else {
              icon.textContent = prize.emoji;
              icon.setAttribute('aria-hidden', 'true');
            }
            label.appendChild(icon);
          }

          if (prize.displayMode !== 'image_only') {
            const text = document.createElement('span');
            text.className = 'rested-wheel__segment-label-text';
            text.textContent = prize.shortTitle;
            label.appendChild(text);
          }

          this.labels.appendChild(label);

          if (this.dividers) {
            const divider = document.createElement('span');
            divider.className = 'rested-wheel__divider';
            divider.style.transform = `translateX(-50%) rotate(${index * step}deg)`;
            this.dividers.appendChild(divider);
          }
        });
      }

      choosePrize() {
        const mode = this.dataset.winMode || 'weighted';

        if (mode === 'fixed') {
          const fixedIndex = Math.max(1, Number.parseInt(this.dataset.fixedPrize, 10) || 1);
          return this.prizes.find((prize) => prize.index === fixedIndex) || this.prizes[0];
        }

        if (mode === 'equal') {
          return this.prizes[Math.floor(Math.random() * this.prizes.length)];
        }

        const weighted = this.prizes.filter((prize) => prize.weight > 0);
        if (!weighted.length) return this.prizes[Math.floor(Math.random() * this.prizes.length)];

        const total = weighted.reduce((sum, prize) => sum + prize.weight, 0);
        let cursor = Math.random() * total;
        for (const prize of weighted) {
          cursor -= prize.weight;
          if (cursor <= 0) return prize;
        }
        return weighted[weighted.length - 1];
      }

      spin() {
        if (this.isSpinning || !this.wheel || !this.prizes.length || !this.canSpin()) return;

        this.isSpinning = true;
        this.result?.setAttribute('hidden', '');
        if (this.spinButton) this.spinButton.disabled = true;
        if (this.spinText) this.spinText.textContent = this.dataset.spinningLabel || 'Върти се…';
        if (this.hint) this.hint.style.opacity = '.45';

        const prize = this.choosePrize();
        const selectedIndex = this.prizes.indexOf(prize);
        const count = this.prizes.length;
        const step = 360 / count;
        const center = (selectedIndex + 0.5) * step;
        const safeJitter = step * 0.24;
        const jitter = (Math.random() * 2 - 1) * safeJitter;
        const targetAngle = center + jitter;

        const minTurns = Math.max(2, Number.parseInt(this.dataset.minTurns, 10) || 5);
        const maxTurns = Math.max(minTurns, Number.parseInt(this.dataset.maxTurns, 10) || 8);
        const fullTurns = minTurns + Math.floor(Math.random() * (maxTurns - minTurns + 1));
        const currentMod = ((this.rotation % 360) + 360) % 360;
        const desiredMod = (360 - targetAngle) % 360;
        const deltaToTarget = (desiredMod - currentMod + 360) % 360;
        const nextRotation = this.rotation + (fullTurns * 360) + deltaToTarget;
        const duration = Math.max(2, Number.parseFloat(this.dataset.spinDuration) || 5.5);

        this.wheel.style.transition = `transform ${duration}s ${this.getEasing()}`;
        this.wheel.style.transform = `rotate(${nextRotation}deg)`;
        this.rotation = nextRotation;
        this.playTickSequence(duration);

        this.setTimer(() => this.finishSpin(prize), duration * 1000 + 80);
      }

      finishSpin(prize) {
        this.isSpinning = false;
        this.spinCount += 1;
        this.lastPrize = prize;
        this.persistState();
        this.showResult(prize);
        this.updateControls();

        if (this.status) {
          const prefix = this.dataset.resultPrefix || 'Спечели';
          const suffix = this.dataset.resultSuffix || '';
          this.status.textContent = `${prefix} ${prize.title}${suffix ? ` ${suffix}` : ''}`;
        }

        if (this.dataset.showConfetti === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.launchConfetti();
        }

        const autoRedirect = this.dataset.autoRedirect === 'true';
        const destination = prize.link || this.dataset.claimLink?.trim();
        const inThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
        if (autoRedirect && destination && !inThemeEditor) {
          const delay = Math.max(1, Number.parseInt(this.dataset.redirectDelay, 10) || 5) * 1000;
          this.setTimer(() => this.claim(), delay);
        }
      }

      showResult(prize, shouldScroll = true) {
        if (!this.result) return;
        this.result.removeAttribute('hidden');

        if (this.resultTitle) {
          const prefix = this.dataset.resultPrefix || '';
          const suffix = this.dataset.resultSuffix || '';
          this.resultTitle.textContent = `${prefix ? `${prefix} ` : ''}${prize.title}${suffix ? ` ${suffix}` : ''}`;
        }
        if (this.resultSubtitle) this.resultSubtitle.textContent = prize.subtitle;

        if (this.resultMedia) {
          this.resultMedia.replaceChildren();
          if (prize.image) {
            const image = document.createElement('img');
            image.src = prize.image;
            image.alt = prize.imageAlt;
            image.loading = 'eager';
            this.resultMedia.appendChild(image);
          } else if (prize.emoji) {
            const emoji = document.createElement('span');
            emoji.textContent = prize.emoji;
            emoji.setAttribute('aria-hidden', 'true');
            this.resultMedia.appendChild(emoji);
          }
          this.resultMedia.hidden = !(prize.image || prize.emoji);
        }

        if (this.couponWrap && this.coupon && this.couponLabel) {
          if (prize.coupon) {
            this.couponWrap.hidden = false;
            this.coupon.textContent = prize.coupon;
            this.couponLabel.textContent = this.dataset.couponPrefix || 'Код за отстъпка';
            if (this.copyLabel) this.copyLabel.textContent = this.dataset.copyLabel || 'Копирай';
          } else {
            this.couponWrap.hidden = true;
          }
        }

        if (shouldScroll) {
          this.result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
        }
      }

      updateControls() {
        if (this.spins) this.spins.textContent = String(this.spinCount);
        if (!this.spinButton) return;

        const canSpin = this.canSpin();
        this.spinButton.disabled = !canSpin;

        if (this.spinText) {
          if (!canSpin) {
            this.spinText.textContent = this.dataset.claimLabel || 'Вземи наградата';
          } else if (this.spinCount > 0) {
            this.spinText.textContent = this.dataset.repeatLabel || this.dataset.spinLabel || 'Завърти пак';
          } else {
            this.spinText.textContent = this.dataset.spinLabel || 'Завърти колелото';
          }
        }
      }

      canSpin() {
        if (!this.prizes.length) return false;
        if (this.dataset.allowRepeat === 'true') {
          const max = Math.max(1, Number.parseInt(this.dataset.maxSpins, 10) || 1);
          return this.spinCount < max;
        }
        return this.spinCount < 1;
      }

      getEasing() {
        const easing = this.dataset.easing;
        if (easing === 'smooth') return 'cubic-bezier(.12,.74,.18,1)';
        if (easing === 'dramatic') return 'cubic-bezier(.05,.82,.12,1)';
        return 'cubic-bezier(.08,.72,.12,1)';
      }

      claim() {
        if (!this.lastPrize) return;
        const link = this.lastPrize.link || this.dataset.claimLink?.trim();
        if (link) {
          window.location.assign(link);
          return;
        }

        let target = null;
        const selector = this.dataset.scrollTarget?.trim();
        if (selector) {
          try { target = document.querySelector(selector); } catch (error) { target = null; }
        }
        if (!target) {
          const sectionWrapper = this.closest('.shopify-section');
          target = sectionWrapper?.nextElementSibling || document.querySelector('form[action*="/cart/add"]');
        }
        target?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }

      async copyCoupon() {
        const value = this.coupon?.textContent?.trim();
        if (!value) return;

        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(value);
          } else {
            const textarea = document.createElement('textarea');
            textarea.value = value;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'absolute';
            textarea.style.left = '-9999px';
            this.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            textarea.remove();
          }
          if (this.copyLabel) this.copyLabel.textContent = this.dataset.copiedLabel || 'Копирано ✓';
          this.setTimer(() => {
            if (this.copyLabel) this.copyLabel.textContent = this.dataset.copyLabel || 'Копирай';
          }, 1800);
        } catch (error) {
          if (this.copyLabel) this.copyLabel.textContent = value;
        }
      }

      restoreState() {
        const mode = this.dataset.storageMode || 'none';
        if (mode === 'none') return;

        try {
          const storage = mode === 'local' ? window.localStorage : window.sessionStorage;
          const raw = storage.getItem(this.storageKey);
          if (!raw) return;
          const data = JSON.parse(raw);
          const count = Math.max(0, Number.parseInt(data.spinCount, 10) || 0);
          this.spinCount = count;
          if (data.prizeIndex) {
            const savedPrize = this.prizes.find((prize) => prize.index === data.prizeIndex);
            if (savedPrize) {
              this.lastPrize = savedPrize;
              this.showResult(savedPrize, false);
            }
          }
        } catch (error) {
          this.spinCount = 0;
        }
      }

      persistState() {
        const mode = this.dataset.storageMode || 'none';
        if (mode === 'none') return;
        try {
          const storage = mode === 'local' ? window.localStorage : window.sessionStorage;
          storage.setItem(this.storageKey, JSON.stringify({ spinCount: this.spinCount, prizeIndex: this.lastPrize?.index || null }));
        } catch (error) {}
      }

      playTickSequence(duration) {
        if (this.dataset.soundEnabled !== 'true') return;
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass) return;

        let ctx;
        try { ctx = new AudioContextClass(); } catch (error) { return; }
        const totalTicks = Math.min(34, Math.max(12, Math.round(duration * 5)));
        for (let i = 0; i < totalTicks; i += 1) {
          const progress = i / totalTicks;
          const delay = (progress * progress * duration * 1000);
          this.setTimer(() => {
            try {
              const oscillator = ctx.createOscillator();
              const gain = ctx.createGain();
              oscillator.type = 'sine';
              oscillator.frequency.value = 520 + Math.random() * 60;
              gain.gain.setValueAtTime(0.025, ctx.currentTime);
              gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.03);
              oscillator.connect(gain);
              gain.connect(ctx.destination);
              oscillator.start();
              oscillator.stop(ctx.currentTime + 0.035);
            } catch (error) {}
          }, delay);
        }
        this.setTimer(() => { try { ctx.close(); } catch (error) {} }, duration * 1000 + 900);
      }

      getConfettiColors() {
        const configured = (this.dataset.confettiColors || '')
          .split(',')
          .map((color) => color.trim())
          .filter(Boolean);
        return configured.length ? configured : ['#2dd4aa', '#0f766e', '#facc15', '#f8fafc'];
      }

      launchConfetti() {
        const amount = Math.max(20, Math.min(160, Number.parseInt(this.dataset.confettiAmount, 10) || 80));
        for (let index = 0; index < amount; index += 1) {
          this.setTimer(() => this.spawnConfettiPiece(), index * 18);
        }
      }

      spawnConfettiPiece() {
        const colors = this.getConfettiColors();
        const piece = document.createElement('span');
        piece.className = 'rested-wheel__confetti';
        piece.style.left = `${Math.random() * 100}vw`;
        piece.style.background = colors[Math.floor(Math.random() * colors.length)];
        piece.style.width = `${5 + Math.random() * 7}px`;
        piece.style.height = `${9 + Math.random() * 10}px`;
        piece.style.borderRadius = Math.random() > .55 ? '50%' : '2px';
        piece.style.transform = `rotate(${Math.random() * 360}deg)`;
        piece.style.animationDuration = `${1.7 + Math.random() * 1.8}s`;
        piece.style.animationDelay = `${Math.random() * .25}s`;
        this.appendChild(piece);
        piece.addEventListener('animationend', () => piece.remove(), { once: true });
      }

      setTimer(callback, delay) {
        const timer = window.setTimeout(() => {
          this.timers = this.timers.filter((item) => item !== timer);
          callback();
        }, delay);
        this.timers.push(timer);
        return timer;
      }
    }

    customElements.define('rested-wheel-to-win', RestedWheelToWin);
  })();

  } catch(e) { console.error(e); }
})();
})();
